import { render, staticRenderFns } from "./DoencasCidSetting.vue?vue&type=template&id=0f7bf64c"
import script from "./DoencasCidSetting.vue?vue&type=script&lang=js"
export * from "./DoencasCidSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports